import React, { useState } from 'react';
import { AccordionItem, Box, Inscription, ShimmerBox } from '@common-fe/common-fe';

import ModalContainer from './ExpressSetupActivateModal/ModalContainer';
import { FAQStyledBox } from './styles/ExpressSetupWizard.styles';
import ExpessSetupWrapper from './ExpessSetupWrapper';
import ExpressSetupBanner from './ExpressSetupBanner';
import { useCurrentExpressSetup } from './hooks';
import { useFundingItems } from './hooks';

const ExpressSetupActivate: React.FC = () => {
  const [isExpanded, setExpanded] = useState(false);
  const { data: expressSetupData, isLoading } = useCurrentExpressSetup();
  const { fundingNextStepsItems } = useFundingItems(expressSetupData);
  return (
    <ExpessSetupWrapper>
      <ExpressSetupBanner
        isActivateMode
        expressSetupData={expressSetupData}
        isLoading={isLoading}
      />
      {
        isLoading ? <ShimmerBox width="100%" height="56px" /> : (
          <FAQStyledBox
            onClick={() => setExpanded(!isExpanded)}
            pad={{ vertical: 'm', horizontal: 'l' }}
            border={{ color: 'border1', size: 'large' }}
            round="container1Round"
            background={isExpanded ? 'border1' : 'canvas'}
            isPageMode
          >
            <AccordionItem
              testId='express-setup-faq-item'
              iconSize='24px'
              isExpanded={isExpanded}
              text={(
                <Box
                  background={isExpanded ? 'border1' : 'canvas'}
                  margin={{ left: 'xxxs' }}
                  direction="row"
                  align="center"
                >
                  <Inscription color="textBody" weight="normal" size='16px' lineHeight='22px'>
                    Next Steps
                  </Inscription>
                </Box>
              )}
              isLeftArrow
            >    
              <Box
                background="border1"
                margin={{ top: 'xs' }}
              >
                <ModalContainer
                  isPageMode
                  items={fundingNextStepsItems}
                />
              </Box>
            </AccordionItem>
          </FAQStyledBox>
        )
      }
    </ExpessSetupWrapper>
  );
};
export default ExpressSetupActivate;
